module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chtit"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_c('b', [_vm._v("Editors’ Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap02"
    }
  }, [_c('b', [_vm._v("Nayomi Munaweera")]), _vm._v("    Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap03"
    }
  }, [_c('b', [_vm._v("Elmaz Abinader")]), _vm._v("    Your Spot on the Wall: Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap04"
    }
  }, [_c('b', [_vm._v("Devi S. Laskar")]), _vm._v("    gr"), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/e.jpg"
    }
  }), _vm._v("-fē'tē    "), _c('i', [_vm._v("poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap05"
    }
  }, [_c('b', [_vm._v("Monique Quintana")]), _vm._v("    Birthday Spells    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Bhaskar Caduveti Rao")]), _vm._v("    The Face Reader    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Kirin Khan")]), _vm._v("    In Public    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Alycia Pirmohamed")]), _vm._v(" "), _c('i', [_vm._v("poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to My Body")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Have the Endings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twisted Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Ramy El-Etreby")]), _vm._v("    My Life is a Tapestry    "), _c('i', [_vm._v("nonfiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Gary Dauphin")]), _vm._v("    Suicide Jacq    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Laura Lucas")]), _vm._v("    Nilscape    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Vickie Vértiz")]), _vm._v("    Winning Prizes for Just Living    "), _c('i', [_vm._v("nonfiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Natalie Graham")]), _vm._v("    Unburning the Body    "), _c('i', [_vm._v("poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Pallavi Dhawan")]), _vm._v("    Stranded    "), _c('i', [_vm._v("nonfiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("L. Penelope")]), _vm._v("    Loop    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tongo Eisen-Martin")]), _vm._v(" "), _c('i', [_vm._v("poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cut A Hand From A Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("may we all refuse to die at the same time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Channels to fall asleep to")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Lin Y. Leong")]), _vm._v("    The Girl and the Moth    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Sarah LaBrie")]), _vm._v("    On Writing    "), _c('i', [_vm._v("nonfiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Cynthia Alessandra Briano")]), _vm._v(" "), _c('i', [_vm._v("poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Maria, Mi Fea, Love, Jesse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Jesse, Love, Maria Guadalupe A.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Tamika Thompson")]), _vm._v("    In a Hard Man’s Town    "), _c('i', [_vm._v("fiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Kay Ulanday Barrett")]), _vm._v(" "), _c('i', [_vm._v("poetry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("While looking at photo albums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhythm is a Dancer, Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Kanika Punwani")]), _vm._v("    Sister    "), _c('i', [_vm._v("nonfiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Contributor Biographies")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0